<!--
    Icons taken from https://www.iconfinder.com
-->

<template>
    <social-sharing :title="title" :quote="title" :media="pinterestImage" inline-template class="d-print-none">
        <div class="share">
            <network network="facebook" id="facebook" class="share-button facebook">
                <IconSvg filepath="social/facebook.svg"></IconSvg>
                <span>{{ $t('Generic.share') }}</span>
            </network>

            <network network="twitter" class="share-button twitter">
                <IconSvg filepath="social/twitter.svg"></IconSvg>
                <span>tweet</span>
            </network>

            <network network="whatsapp" v-if="$root.isMobile" class="share-button whatsapp">
                <IconSvg filepath="social/whatsapp.svg"></IconSvg>
                <span>{{ $t('Generic.share') }}</span>
            </network>

            <network network="pinterest" class="share-button pinterest">
                <IconSvg filepath="social/pinterest.svg"></IconSvg>
                <span>pin it</span>
            </network>
        </div>
    </social-sharing>
</template>

<script>
export default {
    name: 'Share',
    props: {
        title: String,
        pinterestImage: String
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/bootstrap/breakpoints' as breakpoints;

.share {
    $facebook: hsl(221, 44%, 41%);
    $twitter: hsl(206, 82%, 63%);
    $whatsapp: hsl(111, 47%, 52%);
    $pinterest: hsl(353, 92%, 39%);
    $margin-horizontal: 5px;

    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    border-width: 1px 0 0 1px;
    border-radius: 4px;
    margin: 0 - $margin-horizontal;

    ::v-deep .share-button {
        height: 40px;
        line-height: 40px;
        border-width: 0 1px 1px 0;
        box-shadow: none;
        transition: all 0.1s ease-in-out;
        color: hsl(0, 0%, 100%);
        text-align: center;
        cursor: pointer;
        overflow: hidden;
        margin: 0 $margin-horizontal;
        font-size: 0;
        padding: 0 variables.$grid-padding;

        svg {
            height: 1.3em;
            margin-right: 5px;
            width: 30px;
        }

        > svg,
        > span {
            line-height: normal;
            vertical-align: middle;
            display: inline-block;
            font-size: 17px;
        }

        &:hover {
            box-shadow: 0 2px 14px 0 hsla(0, 0%, 100%, 0.32);
        }

        &:first-child:not(:only-child) {
            border-radius: 4px 0 0 4px;
        }

        &:last-child:not(:only-child) {
            border-radius: 0 4px 4px 0;
        }

        &.facebook {
            background-color: $facebook;

            &:hover {
                background-color: rgba($facebook, 0.7);
            }
        }

        &.twitter {
            background-color: $twitter;

            &:hover {
                background-color: rgba($twitter, 0.7);
            }
        }

        &.pinterest {
            background-color: $pinterest;

            &:hover {
                background-color: rgba($pinterest, 0.7);
            }
        }

        &.whatsapp {
            background-color: $whatsapp;

            &:hover {
                background-color: rgba($whatsapp, 0.7);
            }
        }
    }

    @include breakpoints.media-breakpoint-down(variables.$mobile-breakpoint-max) {
        flex-direction: column;
        align-items: center;

        ::v-deep .share-button {
            min-width: 300px;
            margin: 5px auto;
            border-radius: 4px;
        }
    }
}
</style>
